// eslint-disable-next-line import/prefer-default-export
export const language = () => document.documentElement.getAttribute('lang') || 'nl';
